export var noop = function noop() {};


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/utils/noop.js
// module id = null
// module chunks = 